import { mandate as mandateApi } from 'client/redux/api/mandate';
import { selectAuth } from 'client/redux/user/selectors';
import { useAppSelector } from './redux';

export function useMandate(id: string) {
  const { isLoggedIn } = useAppSelector(selectAuth);
  const { data, isFetching } = mandateApi.endpoints.getMandate.useQuery({ id }, { skip: !id || !isLoggedIn });
  const mandate = data?.success ? data.data.mandate : null;
  const seoData = data?.success ? data.data.seoData : null;

  return { mandate, seoData, isFetching };
}
